export const DEFAULT_IMAGE_FILTERS = {
  brightness: 100,
  contrast: 100,
  saturation: 100,
  hue: 0,
  blur: 0,
  sepia: 0,
  grayscale: 0,
};

export const hasNonDefaultImageFilters = (filters) => {
  if (!filters) return false;
  return Object.keys(DEFAULT_IMAGE_FILTERS).some(
    (key) => filters[key] !== undefined && filters[key] !== DEFAULT_IMAGE_FILTERS[key]
  );
};

export const getImageFilterCss = (filters) => {
  if (!filters) return undefined;
  const {
    brightness = 100,
    contrast = 100,
    saturation = 100,
    hue = 0,
    blur = 0,
    sepia = 0,
    grayscale = 0,
  } = filters;

  const parts = [];
  if (brightness !== 100) parts.push(`brightness(${brightness}%)`);
  if (contrast !== 100) parts.push(`contrast(${contrast}%)`);
  if (saturation !== 100) parts.push(`saturate(${saturation}%)`);
  if (hue !== 0) parts.push(`hue-rotate(${hue}deg)`);
  if (blur > 0) parts.push(`blur(${blur}px)`);
  if (sepia > 0) parts.push(`sepia(${sepia}%)`);
  if (grayscale > 0) parts.push(`grayscale(${grayscale}%)`);

  return parts.length ? parts.join(' ') : undefined;
};
